import { observer } from 'mobx-react';
import * as React from 'react';

import { SelectFilterWithSearch } from 'components/Filter/DefaultFilters';

import { distanceStore } from '../stores';

type Props = {
  value: string | number | nil;
} & FilterProps;

@observer
class DisciplineIdComponent extends React.Component<Props> {
  options = () => {
    const distanceModel = distanceStore.modelSelected;

    if (!distanceModel) {
      return [];
    }

    return distanceModel.relationForSelect('disciplines');
  };

  render() {
    const { props } = this;
    return <SelectFilterWithSearch {...props} options={this.options()} />;
  }
}

export const disciplineId: FilterListDescriptor = {
  filter: {
    persistance: {
      handler: '=',

      calcValue: function (name, value) {
        return value;
      },

      prettify: function (name, value) {
        const distance = distanceStore.modelSelected;

        if (!distance) {
          return null;
        }

        const disciplineModel = distance.findRelationModelValue('disciplines', +value);
        return disciplineModel && disciplineModel.label();
      },
    },
  },
  frontend: {
    type: 'custom',
    component: DisciplineIdComponent,
  },
};
